<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [dismissableMask]="true"
  position="center"
  [style]="{width: '56rem', maxWidth: '95vw', height: 'auto'}"
  styleClass="bulk-upload-dialog"
  [header]="dialogTitle"
  (onHide)="onDialogHide()">

  <div class="bulk-upload-body">
  <form [formGroup]="uploadForm" class="bulk-upload-form">
    <!-- Select Party label on its own line (only for multi-party) -->
    <label *ngIf="tabs.length > 1" class="party-label">Select Party</label>

    <!-- Next row: dropdown + Download CSV + Export Masters (inline) -->
    <div class="action-row">
      <p-select
        *ngIf="tabs.length > 1"
        [options]="partyOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="activeTabIndex"
        [ngModelOptions]="{standalone: true}"
        (onChange)="onTabChange($event.value)"
        [style]="{width: '12rem'}"
        appendTo="body">
      </p-select>
      <button
        type="button"
        pButton
        label="Download CSV"
        severity="secondary"
        class="download-template-btn"
        (click)="downloadTemplate()">
      </button>
      <button
        type="button"
        pButton
        label="Export Masters"
        severity="secondary"
        class="export-masters-btn"
        (click)="exportAllMasters()">
      </button>
      <button
        type="button"
        pButton
        label="Uploads Dashboard"
        severity="secondary"
        class="uploads-dashboard-btn"
        (click)="goToUploadsDashboard()">
      </button>
    </div>

    <!-- Upload Section -->
    <div class="upload-area"
         [class.has-file]="selectedFile"
         (click)="!selectedFile && openFileDialog()"
         (dragover)="$event.preventDefault(); $event.stopPropagation()"
         (dragleave)="$event.preventDefault(); $event.stopPropagation()"
         (drop)="onFileDrop($event); $event.preventDefault(); $event.stopPropagation()">

      <input
        #fileInput
        type="file"
        accept=".xlsx,.xls,.csv"
        (change)="onFileSelect($event)"
        style="display: none;">

      <div *ngIf="!selectedFile" class="upload-placeholder">
        <i class="pi pi-upload upload-icon"></i>
        <p class="upload-text">Drag and drop your file here</p>
        <p class="upload-hint">Supported formats: .xlsx, .xls, .csv</p>
        <button
          type="button"
          pButton
          label="Browse Files"
          severity="secondary"
          class="browse-files-btn"
          (click)="$event.stopPropagation(); openFileDialog()">
        </button>
      </div>

      <div *ngIf="selectedFile" class="file-selected">
        <div class="file-info">
          <i class="pi pi-file file-icon"></i>
          <div class="file-details">
            <span class="file-name">{{ fileName }}</span>
            <button
              type="button"
              pButton
              icon="pi pi-times"
              [text]="true"
              [rounded]="true"
              class="remove-file-btn"
              (click)="removeFile()">
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- General Error Message Display (when no validation errors table) -->
  <div *ngIf="errorMessage && !showValidationErrors" class="error-message-section">
    <div class="error-message-box">
      <i class="pi pi-exclamation-triangle error-icon"></i>
      <div class="error-content">
        <span class="error-label">Error</span>
        <span class="error-text">{{ errorMessage }}</span>
      </div>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        [text]="true"
        [rounded]="true"
        class="close-error-btn"
        (click)="errorMessage = ''">
      </button>
    </div>
  </div>

  <!-- Validation Errors Section -->
  <div *ngIf="showValidationErrors && validationErrors.length > 0" class="validation-errors-section">
    <div class="errors-header">
      <div class="errors-title">
        <i class="pi pi-exclamation-triangle error-icon"></i>
        <span class="error-title-text">{{ errorMessage }}</span>
      </div>
      <div class="errors-summary">
        <span class="error-count">Errors: {{ errorCount }}</span>
        <span *ngIf="successCount > 0" class="success-count">Success: {{ successCount }}</span>
      </div>
    </div>
    <div class="errors-table-container">
      <p-table
        [value]="validationErrors"
        [paginator]="true"
        [rows]="10"
        styleClass="validation-errors-table"
        [scrollable]="true"
        scrollHeight="300px">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 80px">Row</th>
            <th>Column</th>
            <th>Value</th>
            <th>Error</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-error>
          <tr>
            <td>{{ error.row }}</td>
            <td>{{ error.column }}</td>
            <td class="error-value">{{ error.value || '-' }}</td>
            <td class="error-message">{{ error.error }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="errors-footer">
      <button
        type="button"
        pButton
        label="Close"
        severity="secondary"
        (click)="closeValidationErrors()">
      </button>
    </div>
  </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        type="button"
        pButton
        label="Cancel"
        severity="secondary"
        (click)="onClose()">
      </button>
      <button
        type="button"
        pButton
        [label]="uploadButtonText"
        [disabled]="!selectedFile || isUploading"
        [loading]="isUploading"
        (click)="onUpload()">
      </button>
    </div>
  </ng-template>
</p-dialog>
